export default __webpack_public_path__ + "static/caption-03-kr-cb656c4b30b80c80f4eb9cff57916dc3.png";